import {ChangeDetectorRef, Component, HostListener, Inject, Input, OnDestroy, OnInit} from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { TranslateService } from "@ngx-translate/core";
import { AuthenticationService } from "../../lib/services/autenticacion/authentication.service";
import { AuthService } from '../../lib/services/auth/auth.service';
import { StorageKeysEnum } from '../../lib/storage/storage-keys.enum';
import { UserUtilsService } from '../../lib/services/user/user-utils.service';
import * as moment from 'moment'
import * as pubsub from "pubsub-js"
import { ProfileImageService } from "../../lib/services/profile-image/profile-image.service";
import { PubsubEnum } from "../../lib/enums/pubsub.enum";
import { NotificationConnectionService } from '../../lib/services/notifications/notification-connection.service';
import { firstValueFrom } from 'rxjs';
import { ToastService } from '../../lib/services/toast/toast.service';
import { Router } from '@angular/router';
import { NpsService } from "../../lib/services/nps/nps.service";
import {FraudProtectionService} from "../../lib/services/fraud-protection/fraud-protection.service";

@Component({
    selector: 'app-navbar',
    templateUrl: './navbar.component.html',
    styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent implements OnInit, OnDestroy {

    fullName: string = "";
    lastLogOn!: formatDate;
    accessToken: any;
    secretWord: any;
    currentLang: string = "es";
    userInfo: any;
    notificationCounter: number = 0;
    showNotificationDialog: boolean = false;
    feedbackToken: String = "";
    activeButton: number = 1;
    notifications: any
    loadingReadNotification: boolean = false;
    loadingDeleteNotification: boolean = false;
    showPendingPaymentAuthorizationModal = false;
    modalData : any = null
    msg: string = "";
    showNotiDialog = true
    @Input() showOnlyTranslateIcon = false;
    @Input() showLogoInNavbar = false;
    checkWindowInterval: any;
    constructor(
        private authentication: AuthenticationService,
        private auth: AuthService,
        public translate: TranslateService,
        private userUtilsService: UserUtilsService,
        private profileImageService: ProfileImageService,
        public notificationConnectionService: NotificationConnectionService,
        private toastService: ToastService,
        private npsService: NpsService,
        private cdr: ChangeDetectorRef,
        private router: Router,
        private fraudProtectionService: FraudProtectionService
    ) {
    }

    ngOnDestroy(): void {
        pubsub.unsubscribe(PubsubEnum.CHANGE_PROFILE_IMAGE)
        pubsub.unsubscribe(PubsubEnum.CLOSE_INACTIVITY_MODALS);
        if (this.checkWindowInterval) {
            clearInterval(this.checkWindowInterval);
        }
    }

    ngOnInit(): void {
        const jwtWso2Decode: string | null = sessionStorage.getItem('JWT_WSO_DECODE');
        const isDiscoveryAlreadyOpened = sessionStorage.getItem('DISCOVER_BANK_TAB_OPEN');
        this.userInfo = this.userUtilsService.getUserInfoSessionStorage()
        this.fullName = this.userInfo?.fullName
        this.currentLang = sessionStorage.getItem(StorageKeysEnum.CURRENT_LANGUAGE) ?? "es"
        moment.locale(this.currentLang)
        this.lastLogOn = this.formatLastLogOn(this.userInfo?.lastLogOn)
        this.accessToken = sessionStorage.getItem(StorageKeysEnum.ACCESS_TOKEN_WSO);
        this.querySecretWord();
        this.subscribeToEvents();
        this.authentication.userPhrase$.subscribe((data)=>{
                this.secretWord = data;
                this.cdr.detectChanges()
        })
        if(jwtWso2Decode) {
            let userObject = JSON.parse(jwtWso2Decode)
                this.fraudProtectionService.fetchFraudConfig(userObject?.idPersona, userObject?.gksessionid).then(()=>{
                    sessionStorage.setItem('FP_AUTHORIZED','true')
                })
        }
        if (isDiscoveryAlreadyOpened) {
            sessionStorage.removeItem('DISCOVER_BANK_TAB_OPEN');
        }
    }

    subscribeToEvents() {
        pubsub.subscribe(PubsubEnum.CHANGE_PROFILE_IMAGE, () => {
            this.userInfo = this.userUtilsService.getUserInfoSessionStorage();
        })
    }

    toggleSidebar(e: Event) {
        e.preventDefault();
        document.body.classList.toggle('sidebar-open');
        pubsub.publish("renderingMenu", e)
    }


    switchLang(lang: string) {
        sessionStorage.setItem(StorageKeysEnum.CURRENT_LANGUAGE, lang)
        this.currentLang = sessionStorage.getItem(StorageKeysEnum.CURRENT_LANGUAGE) ?? "es"
        this.translate.use(this.currentLang);
        moment.locale(this.currentLang)
        this.lastLogOn = this.formatLastLogOn(this.userInfo?.lastLogOn)
        pubsub.publish("changeLanguage", this.currentLang)
    }

    async onLogout($event: any) {
        if (sessionStorage.getItem(StorageKeysEnum.WELCOME) != undefined) {
            this.auth.getFeedbackToken(sessionStorage.getItem(StorageKeysEnum.ACCESS_TOKEN_WSO));
        }
        if (this.npsService.showNps) {
            await this.router.navigate(['/nps']);
        } else {
            this.auth.logOut();
        }
    }

    formatLastLogOn(dateReceive: string) {
        const splitDate = dateReceive.split(" ")
        const day = splitDate[0]
        const hour = splitDate[1]

        const date = this.currentLang == "es" ? moment(day, "DD/MM/YYYY").format("D [de] MMMM [de] YYYY") : moment(day, "DD/MM/YYYY").format("D MMMM, YYYY")
        return {
            date,
            hour
        }
    }

    querySecretWord() {
        this.authentication.querySecret(this.accessToken).subscribe({
            next: value => {
                this.secretWord = value?.secret;
                if (!this.userInfo['userImage'] && value.imgBytes != null) {
                    this.userUtilsService.setUserInfoSessionStorage({ userImage: 'data:image/png;base64,' + value.imgBytes })
                }
            },
            error: err => {
                console.log(err);
                return
            }
        });
    }

    editProfileImage() {
        this.profileImageService.openModal();
    }

    calculateInitials() {
        return this.userUtilsService.calculateInitials();
    }

    showNotificationBanner() {
        this.showNotificationDialog = !this.showNotificationDialog
    }

    setNotifications(event: Event, activeNumber: number) {
        event.preventDefault()
        this.activeButton = activeNumber
    }

    async setReadNotification(idNotification: number) {
        this.loadingReadNotification = true
        try {
            await firstValueFrom(this.notificationConnectionService.setReadNotificationApi(idNotification))
        } catch (error) {
            console.log(error)
            this.loadingReadNotification = false
            return
        }
        this.loadingReadNotification = false
        await this.notificationConnectionService.getApiNotifications()
        const msg = await firstValueFrom(this.translate.get("NOTF_SUCCESS"))
        const summary = await firstValueFrom(this.translate.get("NOTF_TITLE"))
        this.toastService.showToast(msg, "success", summary)
    }

    async deleteNotification(notificationId: number) {
        const summary = await firstValueFrom(this.translate.get("NOTF_TITLE"))
        this.loadingDeleteNotification = true
        try {
            await firstValueFrom(this.notificationConnectionService.deleteNotificationAPI(notificationId));
        } catch (error) {
            console.log(error);
            this.loadingDeleteNotification = false
            const msg = await firstValueFrom(this.translate.get("NOTIFICATIONS.ERROR_DELETING_NOTIFICATION"))
            this.toastService.showToast(msg, "error", summary)
            return
        }
        this.loadingDeleteNotification = false
        await this.notificationConnectionService.getApiNotifications()
        const msg = await firstValueFrom(this.translate.get("NOTIFICATIONS.SUCCESS_DELETE"))
        this.toastService.showToast(msg, "success", summary)
        return
    }

    async updateAllNotifications(action: String) {
        this.loadingReadNotification = true
        try {
            await firstValueFrom(this.notificationConnectionService.updateAllNotifications(action))
        } catch (error) {
            console.log(error)
            this.loadingReadNotification = false
            return
        }
        this.loadingReadNotification = false
        await this.notificationConnectionService.getApiNotifications()


        if(action == "read"){
             this.msg = await firstValueFrom(this.translate.get("NOTF_ALL_SUCCESS"))
        }else{
             this.msg = await firstValueFrom(this.translate.get("NOTF_ALL_SUCC_DEL"))
        }

        const summary = await firstValueFrom(this.translate.get("NOTF_TITLE"))
        this.toastService.showToast(this.msg, "success", summary)
    }

    capitalizeWord(text: string){
        return text.toLowerCase().split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ')
    }


    navbarHidden = false
    private lastScrollTop = 0;
    @HostListener('window:scroll', [])
    onWindowScroll(): void {
        const currentScroll = window.scrollY || document.documentElement.scrollTop;
        if (currentScroll > this.lastScrollTop) {
           // console.log(this.lastScrollTop)
            this.navbarHidden = true;
        } else {
            //console.log(this.lastScrollTop)
            this.navbarHidden = false;
        }
        this.lastScrollTop = currentScroll <= 0 ? 0 : currentScroll
    }

    private isChromeOnWindows(): boolean{
        const userAgent = navigator.userAgent.toLowerCase();
        return userAgent.includes('chrome') && userAgent.includes('win')
    }

    @HostListener('window:resize', ['$event'])
    onResize(event: Event): void {
    }

    onClosePendingPaymentsAuthorizationModalEvent() {
        this.showPendingPaymentAuthorizationModal = false;
        this.modalData = null
    }
    openModal(data: any){
        this.modalData = data;
        //console.log(this.modalData, data.idNotificacion)
        this.showPendingPaymentAuthorizationModal = true;
    }
    hideNotificationDialog(){
        this.showNotiDialog = false
        setTimeout(()=>{
            this.showNotiDialog = true
        }, 1000)
    }


    redirectDiscoverUBank() {
        const sessionKey = 'DISCOVER_BANK_TAB_OPEN';
        const isAlreadyOpened = sessionStorage.getItem(sessionKey);
        const url = this.router.serializeUrl(this.router.createUrlTree(['/nueva-banca-digital/discover-your-bank']))
        const fullURL = location.origin+'/nueva-banca-digital/#'+url;
        if (isAlreadyOpened) {
            const openedWindow = window.open('', 'DiscoverBankPage');
            if (openedWindow && !openedWindow.closed) {
                openedWindow.focus();
                openedWindow.postMessage('focus', '*');
            } else {
                // Si la ventana está cerrada pero el sStorage aún existe
                sessionStorage.removeItem(sessionKey);
                this.openNewDiscoverWindow(fullURL, sessionKey);
            }
            return;
        }
        sessionStorage.setItem(sessionKey, 'true');
        this.openNewDiscoverWindow(fullURL, sessionKey);
    }

    private openNewDiscoverWindow(fullURL: string, sessionKey: string) {
        const newWindow = window.open(fullURL, 'DiscoverBankPage');
        if (newWindow) {
            window.addEventListener('message', (event) => {
                if (event.data === 'focus') {
                    newWindow.focus();
                }
            });
            if (this.checkWindowInterval) {
                clearInterval(this.checkWindowInterval);
            }
            this.checkWindowInterval = setInterval(() => {
                if (newWindow.closed) {
                    sessionStorage.removeItem(sessionKey);
                    sessionStorage.removeItem('ACT_USR_STATE')
                    clearInterval(this.checkWindowInterval);
                    this.checkWindowInterval = null;
                }
            }, 1500);
        }
    }
}


type formatDate = {
    date: string,
    hour: string
}


/*
pasar tiponotificacion para que se muestre un template u otro
armar template con ts y mostrarlo con innerHTML
*/
